export default "__VITE_ASSET__B6oZ8Vco__"